// extracted by mini-css-extract-plugin
export default {"container":"qO-z","topReviewHeading":"rO-z","criticalReview":"sO-z","favorableReview":"tO-z","vsSeparator":"uO-z"};